import React, { useContext, useEffect, useState } from "react";
import { getQuoteMarketing } from "./service/subCabeceraService";
import useTokenValidation from "../../../../../../hooks/useTokenValidation";
import { useGlobalContext } from "../../../../../../context/GlobalContext";
import { Oval } from "react-loader-spinner";
import UniversalIconPerfil from "../../../../../../components/UniversalIconoPerfil/UniversalIconPerfil";
import { WindowSizeContext } from "../../../../../../context/WindowSizeContext";

export default function SubCabecera({ scrollRef }) {
  /* 1. ─────────────── CONTEXT & ESTADOS BÁSICOS ─────────────── */
  const { width } = useContext(WindowSizeContext);

  const [isMobile, setIsMobile]     = useState(width < 479);
  const [isModalOpen, setIsModalOpen] = useState(width < 479);
  const [closedByUser, setClosedByUser] = useState(false);   // ← NUEVO

  const [quotesList, setQuotesList]   = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const { tokenEntity }                     = useTokenValidation();
  const { perfil, errorPerfil, loadingPerfil } = useGlobalContext();

  const [vIsScrollTop, setVIsScrollTop] = useState(true);

  /* 2. ─────────────── API QUOTES ─────────────── */
  const fetchInitialQuote = () => {
    getQuoteMarketing(null, tokenEntity.token)
      .then((res) => (res.ok ? res.json() : Promise.reject(res)))
      .then((result) => {
        if (
          result.detail?.acción === "QUOTE_MARKETING_OBTENIDAS" &&
          result.detail.datos?.seleccion?.actually
        ) {
          setQuotesList([result.detail.datos.seleccion.actually]);
          setCurrentIndex(0);
        }
      })
      .catch((err) => console.error("Error inicial quotes →", err));
  };

  const fetchNewQuote = () => {
    const ids = quotesList.map((q) => q.id).join(",");
    getQuoteMarketing(ids, tokenEntity.token)
      .then((res) => (res.ok ? res.json() : Promise.reject(res)))
      .then((result) => {
        if (result.detail?.acción === "NUEVO_QUOTE_OBTENIDO") {
          setQuotesList((prev) => [...prev, result.detail.datos]);
          setCurrentIndex((prev) => prev + 1);
        } else if (result.detail?.acción === "TODOS_UTILIZADOS") {
          setCurrentIndex((prev) => (prev + 1) % quotesList.length);
        }
      })
      .catch((err) => console.error("Error nueva quote →", err));
  };

  /* 3. ─────────────── MONTAJE INICIAL ─────────────── */
  useEffect(() => {
    if (!tokenEntity.isValidando) fetchInitialQuote();
  }, [tokenEntity.isValidando]);

  /* Scroll header transparencias */
  useEffect(() => {
    const scrollEl = scrollRef.current;
    if (!scrollEl) return;

    const onScroll = () =>
      setVIsScrollTop(scrollEl.scrollTop <= 0);

    scrollEl.addEventListener("scroll", onScroll);
    return () => scrollEl.removeEventListener("scroll", onScroll);
  }, [scrollRef]);

  /* 4. ─────────────── RESPONSIVE: abre/cierra modal automáticamente ─────────────── */
  useEffect(() => {
    const mobile = width < 479;
    setIsMobile(mobile);

    if (!mobile) {
      /* Pasamos a vista desktop → siempre cerramos el modal
         y “reseteamos” el cierre manual. */
      setIsModalOpen(false);
      if (closedByUser) setClosedByUser(false);
    } else {
      /* Entramos a vista móvil:
         – Si NO lo cerró manualmente, lo mostramos.
         – Si sí lo cerró, lo dejamos cerrado. */
      if (!closedByUser) setIsModalOpen(true);
    }
  }, [width, closedByUser]);

  /* 5. ─────────────── CAMBIO AUTOMÁTICO DE QUOTE EN MODAL ─────────────── */
  const autoChangeQuote = () =>
    setCurrentIndex((prev) => {
      const nxt = (prev + 1) % quotesList.length;
      if (nxt === 0) fetchNewQuote();
      return nxt;
    });

  useEffect(() => {
    if (isModalOpen && isMobile && quotesList.length) {
      const ms = Math.floor(Math.random() * 5000) + 10000; // 10-15 s
      const id = setTimeout(autoChangeQuote, ms);
      return () => clearTimeout(id);
    }
  }, [isModalOpen, isMobile, quotesList, currentIndex]);

  /* 6. ─────────────── HANDLERS ─────────────── */
  const handleNext = () => {
    if (!quotesList.length) return;
    if (!isModalOpen) fetchNewQuote();
  };

  const handlePrevious = () =>
    setCurrentIndex((prev) => (prev - 1 + quotesList.length) % quotesList.length);

  const closeModal = () => {
    setIsModalOpen(false);
    setClosedByUser(true); // ← recuerda que el usuario lo cerró
  };

  /* 7. ─────────────── UI – LOADING / ERROR ─────────────── */
  if (loadingPerfil) {
    return (
      <Oval visible height={50} width={50} color="#fff" secondaryColor="#f5f5f5" />
    );
  }
  if (errorPerfil) return <p>Error: {errorPerfil}</p>;

  const currentQuote = quotesList[currentIndex];

  /* 8. ─────────────── RENDER ─────────────── */
  return (
    <>
      {/* Header fijo */}
      <div
        className="header-style"
        style={{ backgroundColor: vIsScrollTop ? "transparent" : "#1d1d1d" }}
      >
        <p className="header-texto">
          Hola, {perfil.datos.informacion_del_usuario.nombre_completo}
        </p>
        <div className="header-iconos">
          <i className="fi fi-rs-bell bell-1-2" />
          <UniversalIconPerfil />
        </div>
      </div>

      {/* Carrusel */}
      <div className="home-header-2">
        <div className="publicidad-home">
          <img
            src="../images/angle-circle-left-1.svg"
            className="angle-circle-left-1-2"
            loading="lazy"
            onClick={handlePrevious}
            style={{ cursor: "pointer" }}
            alt=""
          />

          <div className="publicidad-1-info">
            {currentQuote && (
              <>
                <p className="publicidad-1-info-texto-1">
                  {currentQuote.quote_principal}
                </p>
                <p className="publicidad-1-info-texto-2">
                  {currentQuote.quote_secundaria}
                </p>
              </>
            )}
          </div>

          <img
            src="../images/angle-circle-right-1.svg"
            className="angle-circle-right-1-2"
            loading="lazy"
            onClick={handleNext}
            style={{ cursor: "pointer" }}
            alt=""
          />
        </div>
      </div>

      {/* Modal SOLO en móvil */}
      {isModalOpen && isMobile && (
        <div className="publicidad-home-movil">
          <i className="fi fi-rr-cross cross-2" onClick={closeModal} />
          <div className="publicidad-home-movil-contenido">
            <div className="publicidad-home-movil-info">
              <img
                src="../images/Frame-25.png"
                className="imagen-publicidad-1"
                loading="lazy"
                alt=""
              />
              {currentQuote && (
                <>
                  <p className="publicidad-1-info-texto-1-2">
                    {currentQuote.quote_principal}
                  </p>
                  <p className="publicidad-1-info-texto-2-2">
                    {currentQuote.quote_secundaria}
                  </p>
                </>
              )}
            </div>
            <div className="boton-publicidad">
              <p className="comenzar" onClick={closeModal}>
                Comenzar
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}